import { uniqBy } from 'lodash';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import { connect } from 'react-redux';

import { changeCampaign } from '../campaign-editor/actions';
import {
  offerTypes,
  productswithExtraChecksForContentIds,
} from '../products/constants';
import getEventTargetValue from '../utils/get-event-target-value';
import {
  deleteCreative,
  loadCreatives,
  resizeCreativeImage,
  saveAllCreatives,
  updateCreative,
  uploadCreatives,
} from './actions';
import {
  addContentfulCreatives,
  deleteContentfulCreatives,
  saveAllContentfulCreatives,
  updateContentfulCreatives,
} from './ContentfulCreatives/actions';
import CreativesModal from './CreativesModal';

export default connect(
  ({ creativeAssets, campaignEditor, contentfulCreatives }, props) => {
    const context = get(creativeAssets, ['context'], {});
    const campaignProductTags =
      campaignEditor && campaignEditor.campaignLinesById
        ? uniq(
            Object.values(campaignEditor.campaignLinesById)
              .filter(cl => cl.productTag)
              .map(item => item.productTag),
          )
        : [];
    const campaignLineProductsSupportingContentIds =
      campaignEditor && campaignEditor.campaignLinesById
        ? uniqBy(
            Object.values(campaignEditor.campaignLinesById)
              .filter(cl => {
                const productMeta =
                  campaignEditor &&
                  campaignEditor.campaign.productMetas.find(
                    pr => pr.productId === cl.product.id,
                  );
                if (
                  productswithExtraChecksForContentIds.includes(cl.product.code)
                ) {
                  return (
                    cl.product.supportsContentIds &&
                    (cl.offerType === offerTypes.HPTO ||
                      cl.offerType === offerTypes.M1TO ||
                      (cl.offerType === offerTypes.GUARANTEED &&
                        productMeta.proposition !== undefined))
                  );
                }
                return cl.product.supportsContentIds;
              })
              .map(item => ({
                label: item.product.label,
                value: item.product.id,
                code: item.product.code,
              })),
            'value',
          )
        : [];
    return {
      initialized: context.opportunityId === props.opportunityId,
      campaignProductMetas:
        campaignEditor && campaignEditor.campaign.productMetas,
      campaignId: campaignEditor && campaignEditor.campaign.id,
      campaignProductTags,
      campaignLineProducts: campaignLineProductsSupportingContentIds,
      contentfulCreatives,
      creatives: Object.values(creativeAssets.creativesById).map(creative => {
        return {
          campaignProductTags,
          ...creative,
        };
      }),
    };
  },
  {
    loadCreatives,
    onAddMultiple: uploadCreatives,
    onDelete: deleteCreative,
    onUpdate: updateCreative,
    onSaveAll: saveAllCreatives,
    changeCampaign,
    resizeCreativeImage,
    onAddContentfulCreatives: addContentfulCreatives,
    onUpdateContentfulCreatives: updateContentfulCreatives,
    onSaveAllContentfulCreatives: saveAllContentfulCreatives,
    onDeleteContentfulCreatives: deleteContentfulCreatives,
  },
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    initialize() {
      if (!stateProps.initialized) {
        dispatchProps.loadCreatives({ opportunityId: ownProps.opportunityId });
      }
    },
    onChangeCampaign: event =>
      dispatchProps.changeCampaign(
        event.target.name,
        getEventTargetValue(event.target),
      ),
    onExit() {
      if (stateProps.creatives.find(cr => cr.edited)) {
        dispatchProps.loadCreatives({ opportunityId: ownProps.opportunityId });
      }
    },
  }),
)(CreativesModal);
